<div class="dialog-header">
  <div class="dialog-title">
    <h1>
      Add Category
      <!-- {{ id ? ("editFamily" | translate) : ("newFamily" | translate) }} -->
    </h1>
  </div>

  <a href="javascript:;" class="dialog-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="dialog-content">
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form nzLayout="vertical" [formGroup]="form" (submit)="save()">
      <nz-form-item>
        <nz-form-label nzFor="name" nzRequired>{{
          "name" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="name"
            id="name"
            [placeholder]="'name' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <div class="mt-4">
        <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">
          {{ id ? ("saveChanges" | translate) : ("add" | translate) }}
        </button>
        <button
          nz-button
          (click)="close()"
          type="button"
          class="ml-2"
          [disabled]="isSaving"
        >
          {{ "cancel" | translate }}
        </button>
      </div>
    </form>
  </nz-spin>
</div>
